<template>
<div>

     <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>



  <div v-if="type=='A'">

  <div v-if="newSupplier">
    <newSupplier @close="newSupplier=false" :item={}></newSupplier>
  </div> 

  <div v-else>
  

        <div class="card border-0">

          <div class="btn-group" role="group" aria-label="Basic example">
        <button  @click="$emit('close')" type="button"  class="btn  btn-secondary mb-1 ">
        <i style="color:yellow" class="fas fa-edit mr-2" aria-hidden="true"></i>
          RITORNA A RICERCA ORDINE
        </button>       
          
        <button  @click="newSupplier=true" type="button"  class="btn  btn-primary mb-1 ">
        <i style="color:yellow" class="fas fa-edit mr-2" aria-hidden="true"></i>
          NUOVO FORNITORE  
        </button>  
           </div>

        </div>



 

  <form id="order" v-on:submit.prevent="controlloEsistenzaOrdine()" >

      <h4><i class="fas fa-edit mr-2" aria-hidden="true"></i>NUOVO ORDINE - INTESTAZIONE</h4>
          
      <div class="form-group">

      <collection-select v-bind:props="collection" @update="setCollectionId"></collection-select>      
        <supplier-select  v-bind:Id="order.supplierId" v-bind:isActive="true" @update="setSupplierId"></supplier-select>
      </div>
       
      
      <div class="form-group">
        <label for="number_doc"><strong>Numero ordine</strong></label>
        <input v-model="order.order_num" type="text" class="form-control bold" placeholder=""  id = "order_num" required>
      </div>

      <div class="form-group">
        <label for="order_date"><strong>Data ordine</strong></label>
        <input required v-model="order.order_date" type="date" class="form-control bold" placeholder="" id = "order_date">
      </div>

      <div class="form-group">
        <store-select v-bind:Id="order.storeId"  @update="setStoreId" v-bind:isActive="true" v-bind:required="true"></store-select>
      </div>
          
      

      <button  type="submit"  class="btn btn-primary float-right mr-3">
        <i class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
        PROCEDI      
      </button>
    
  </form>

  </div>
  </div>

  <div v-else>

     <form id="order" v-on:submit.prevent="submit2()" >
      
      <div class="card border-info">
      <div  class="card-header text-white bg-info">
        <h4><i class="fas fa-edit mr-2" aria-hidden="true"></i>MODIFICA INTESTAZIONE ORDINE</h4>
      </div>
      <div style="color:black" class="card-body">        
      
      <div class="form-group">                
        <supplier-select   v-bind:Id="order.supplierId" v-bind:isActive="false" @update="setSupplierId"></supplier-select>
      </div>
       <div class="form-group">                
        <collection-select :key="refresh" v-bind:props="collection" @update="setCollectionId"></collection-select>  
      </div>
     
      
      <div class="form-group">
        <label for="number_doc"><strong>NUMERO ORDINE</strong></label>
        <input v-model="order.order_num" type="text" class="form-control bold" placeholder=""  id = "order_num" required>
      </div>
      <div class="form-group">
        <label for="order_date"><strong>DATA ORDINE</strong></label>
        <input required v-model="order.date" type="date" class="form-control bold" placeholder="" id = "order_date">
      </div>

      <div class="form-group">
        <store-select :key="refresh" v-bind:Id="order.storeId"  @update="setStoreId" v-bind:isActive="true" v-bind:required="true"></store-select>
      </div>
      
      </div>

     
    </div>
        
    <button  type="submit"   class="btn btn-primary float-right mr-3 mt-1">
      <i class="fas fa-save mr-2" aria-hidden="true"></i>
      MODIFICA
      
    </button>
    
  </form>


  </div>  

<!-- MAIN DIV -->
</div>

</template>
<script>


import api              from '@/api'
import supplierSelect   from '@/components/common/SupplierSelect.vue'   


import storeSelect      from '@/components/common/StoreSelect.vue' 
import newSupplier      from '@/components/supplier/Supplier.vue' 
import collectionSelect from '../common/CollectionSelect_1.vue'


import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'

import { mapGetters } from 'vuex';

export default {
  
  components: {supplierSelect,storeSelect,newSupplier,collectionSelect,modalMessage,modalConfirm},  
  
  props: ['_order','type'],

  data () {
    return {

      newSupplier : false,
      order       : this._order ,      
     
      refresh     : 0,
      collection  : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        typeId        : 1


      },
    
      
      
  }
  },

computed: 
  {

    ...mapGetters(['company'])

  },

mounted()
{

},
created()
{
  
  this.collection.Id = this._order.collectionId

  // collection
  this.refresh++
  
},
methods: 
{
  setCollectionId(Id)
  {
    
    //this.collection.Id = Id    
    this.order.collectionId = Id
    
  },
  setSupplierId(supplierId)
  {
    this.order.supplierId = supplierId
  },
 
  setStoreId(storeId)
  {
    this.order.storeId = storeId
  },


  async order_checkIn()
  {


    const sp      = 'spOrder_CheckInByCollection'
    const payload = {...this.order, sp,'companyId' : this.company.Id}
    this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})    

      try{
              const res = await api.post(payload)
              if (res.status !== 200) 
              {
                  throw new Error(res.data ||  res)
              }
              
              this.$refs.msgModal.close()
              return res.data.recordsets[0]
          }
            catch(err)    
          {
            this.$refs.msgModal.show(err)   
          }
      
  },


  

  apriOrdine()
  {
    
    this.$emit('update',this.order)
  },

  async controlloEsistenzaOrdine() 
  {
    
    try {

        const response = await this.order_checkIn()
         

        if(response.length > 0)
        {

            this.order.orderId =  response[0].orderId
           
            this.$refs.msgModal.show('Intestazione ordine già esistente.')       
            return
        
        }

        this.submit()  
      
        } catch (err) {
        
                
            this.$refs.msgModal.show(err)       
            
        }

    },  

  async submit() 
  {

    const sp  = 'spCreateSupplierOrderNew'
    this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})        
    const payload = {...this.order,sp,'companyId' : this.company.Id}
    

    try{
      const res = await api.post(payload)
        if (res.status !== 200) 
        {
          throw new Error(res.data ||  res)
        }

        this.$refs.msgModal.close()
        await this.$refs.msgModal.show('REGISTRAZIONE ORDINE ESEGUITA.')
        
        this.order = res.data.recordsets[0][0]
        this.$emit('update',this.order)         

      }catch(err)
       {
          this.$refs.msgModal.show(err)
       }

   
	},
  
  async submit2() 
  {
        
   
    const sp           = 'spUpdateOrderHeaderCollection'
    const payload      = {...this.order, sp,'companyId':this.company.Id};
    
  
     try{

        const res = await api.post(payload)
        if (res.status !== 200) 
        {
          throw new Error(res.data ||  res)
        }
        this.$refs.msgModal.close()
        if(res.data.recordsets[0][0].orderId == 0)
        {
          await this.$refs.msgModal.show('INTESTAZIONE ORDINE GIA\' ESISTENTE.')  
          return
        }
        
        this.$emit('update')
        await this.$refs.msgModal.show('INTESTAZIONE MODIFICATA.')  
        
        
        }catch(err)
        {
          this.$refs.msgModal.show(err)
        }
   
	}
        
}
    
}    
</script>

<style scoped>

.bold {
  font-weight: bolder;
}

h4 {

  font-family: 'Roboto Condensed';
  font-size: 20px;
}

</style>